import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { loadData } from "../../../functions/dataLoader";

export const initBattleContents = createAsyncThunk("battleContents/init", async () => {
    const [battleContents, monsters, buffs] = await Promise.all([
        loadData("battle_contents.json"),
        loadData("monsters.json"),
        loadData("buffs.json"),
    ]);
    return { battleContents, monsters, buffs };
});

const battleContentSlice = createSlice({
    name: "battleContents",
    initialState: {
        battleContents: null,
        monsters: null,
        buffs: null,
        status: "idle",
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(initBattleContents.fulfilled, (state, action) => {
            state.battleContents = action.payload.battleContents;
            state.monsters = action.payload.monsters;
            state.buffs = action.payload.buffs;
            state.status = "done";
        });
    },
});

export default battleContentSlice.reducer;
